/** Per-user display preferences, cached locally and synced across devices. */
import { unwrap } from "@tern/api-client";
import { api } from "./api";
import { instancePath } from "./instance";
import { createViewStore } from "./viewStore";

export { DEFAULT_VIEW, type Layout, type ViewSettings } from "./viewSettings";

export const useViews = createViewStore({
  namespace: instancePath,
  storage: () => localStorage,
  load: async signal => unwrap(await api.GET("/api/me/views", { signal: AbortSignal.any([signal, AbortSignal.timeout(5_000)]) })),
  save: async (key, settings, signal) => unwrap(await api.PUT("/api/me/views/{key}", {
    params: { path: { key } }, body: settings as unknown as Record<string, never>,
    keepalive: new TextEncoder().encode(JSON.stringify(settings)).length < 16_000,
    signal: AbortSignal.any([signal, AbortSignal.timeout(5_000)]),
  })),
});

// Flush the debounce when leaving the page; unsynced data is also cached locally.
if (typeof window !== "undefined") {
  window.addEventListener("pagehide", () => { void useViews.getState().flush(); });
  document.addEventListener("visibilitychange", () => { if (document.hidden) void useViews.getState().flush(); });
}
